"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrandLang = exports.getBrandKeysForUnits = exports.assertBrandKey = exports.isBrandKey = exports.brandTitleByKey = exports.brandKeysByUnit = exports.BrandKey = void 0;
const unit_js_1 = require("./unit.js");
var BrandKey;
(function (BrandKey) {
    BrandKey["ATN"] = "ATN";
    BrandKey["BEA"] = "BEA";
    BrandKey["BIN"] = "BIN";
    BrandKey["BONE"] = "BONE";
    BrandKey["BRGTS"] = "BRGTS";
    BrandKey["BROMM"] = "BROMM";
    BrandKey["CAC"] = "CAC";
    BrandKey["CAM"] = "CAM";
    BrandKey["CAP"] = "CAP";
    BrandKey["CBG"] = "CBG";
    BrandKey["CLE"] = "CLE";
    BrandKey["CTR"] = "CTR";
    BrandKey["CTM"] = "CTM";
    BrandKey["CTP"] = "CTP";
    BrandKey["DEGTS"] = "DEGTS";
    BrandKey["DEOMM"] = "DEOMM";
    BrandKey["DESAS"] = "DESAS";
    BrandKey["ESGTS"] = "ESGTS";
    BrandKey["ESOMM"] = "ESOMM";
    BrandKey["FAC"] = "FAC";
    BrandKey["FATV"] = "FATV";
    BrandKey["FDI"] = "FDI";
    BrandKey["FLW"] = "FLW";
    BrandKey["FRGTS"] = "FRGTS";
    BrandKey["FRGSD"] = "FRGSD";
    BrandKey["FRGSG"] = "FRGSG";
    BrandKey["FRGSL"] = "FRGSL";
    BrandKey["FRGSS"] = "FRGSS";
    BrandKey["FRGSV"] = "FRGSV";
    BrandKey["FROMM"] = "FROMM";
    BrandKey["GAL"] = "GAL";
    BrandKey["GEO"] = "GEO";
    BrandKey["HBR"] = "HBR";
    BrandKey["HBZ"] = "HBZ";
    BrandKey["HCO"] = "HCO";
    BrandKey["IDE"] = "IDE";
    BrandKey["IDEAT"] = "IDEAT";
    BrandKey["ICI"] = "ICI";
    BrandKey["ITGTS"] = "ITGTS";
    BrandKey["ITOMM"] = "ITOMM";
    BrandKey["JDD"] = "JDD";
    BrandKey["JDM"] = "JDM";
    BrandKey["JDN"] = "JDN";
    BrandKey["MAD"] = "MAD";
    BrandKey["MAN"] = "MAN";
    BrandKey["MCE"] = "MCE";
    BrandKey["MCO"] = "MCO";
    BrandKey["MCS"] = "MCS";
    BrandKey["MLK"] = "MLK";
    BrandKey["MVO"] = "MVO";
    BrandKey["NEO"] = "NEO";
    BrandKey["NGE"] = "NGE";
    BrandKey["OMM"] = "OMM";
    BrandKey["PMEDIA"] = "PMEDIA";
    BrandKey["PRA"] = "PRA";
    BrandKey["QUOI"] = "QUOI";
    BrandKey["SESH"] = "SESH";
    BrandKey["SHGCAC"] = "SHGCAC";
    BrandKey["SHGCAM"] = "SHGCAM";
    BrandKey["SHGFAC"] = "SHGFAC";
    BrandKey["SHGGEO"] = "SHGGEO";
    BrandKey["SHGTEL"] = "SHGTEL";
    BrandKey["SHGVOI"] = "SHGVOI";
    BrandKey["SIM"] = "SIM";
    BrandKey["SRG"] = "SRG";
    BrandKey["TEL"] = "TEL";
    BrandKey["TGC"] = "TGC";
    BrandKey["TLA"] = "TLA";
    BrandKey["TGL"] = "TGL";
    BrandKey["TMA"] = "TMA";
    BrandKey["TLZ"] = "TLZ";
    BrandKey["TLS"] = "TLS";
    BrandKey["TRV"] = "TRV";
    BrandKey["TVJ"] = "TVJ";
    BrandKey["TVP"] = "TVP";
    BrandKey["TVS"] = "TVS";
    BrandKey["UKGTS"] = "UKGTS";
    BrandKey["UKOMM"] = "UKOMM";
    BrandKey["UKSAS"] = "UKSAS";
    BrandKey["VDF"] = "VDF";
    BrandKey["VOI"] = "VOI";
    BrandKey["TESTBRAND"] = "TESTBRAND";
})(BrandKey = exports.BrandKey || (exports.BrandKey = {}));
exports.brandKeysByUnit = {
    [unit_js_1.Unit.BIN]: [BrandKey.BIN],
    [unit_js_1.Unit.CAM]: [BrandKey.CAM],
    [unit_js_1.Unit.CBG]: [BrandKey.CBG],
    [unit_js_1.Unit.CEBR]: [BrandKey.BRGTS, BrandKey.BROMM],
    [unit_js_1.Unit.CEDE]: [BrandKey.DEGTS, BrandKey.DEOMM],
    [unit_js_1.Unit.CEES]: [BrandKey.ESGTS, BrandKey.ESOMM],
    [unit_js_1.Unit.CEIT]: [BrandKey.ITGTS, BrandKey.ITOMM],
    [unit_js_1.Unit.CEUK]: [BrandKey.UKGTS, BrandKey.UKOMM],
    [unit_js_1.Unit.CLE]: [BrandKey.CLE],
    [unit_js_1.Unit.CTM]: [BrandKey.CTM, BrandKey.MCE, BrandKey.MCO, BrandKey.MCS],
    [unit_js_1.Unit.FATV]: [BrandKey.FATV],
    [unit_js_1.Unit.FDI]: [BrandKey.FDI],
    [unit_js_1.Unit.FRGTS]: [
        BrandKey.FRGTS,
        BrandKey.FRGSD,
        BrandKey.FRGSG,
        BrandKey.FRGSL,
        BrandKey.FRGSS,
        BrandKey.FRGSV,
    ],
    [unit_js_1.Unit.FROMM]: [BrandKey.FROMM],
    [unit_js_1.Unit.GALA]: [BrandKey.GAL],
    [unit_js_1.Unit.GEO]: [BrandKey.GEO],
    [unit_js_1.Unit.HBZ]: [BrandKey.HBZ],
    [unit_js_1.Unit.HCO]: [BrandKey.HCO],
    [unit_js_1.Unit.IDE]: [BrandKey.IDEAT, BrandKey.IDE],
    [unit_js_1.Unit.ICI]: [BrandKey.ICI],
    [unit_js_1.Unit.JDD]: [BrandKey.JDD],
    [unit_js_1.Unit.JDM]: [BrandKey.JDM],
    [unit_js_1.Unit.JDN]: [BrandKey.JDN],
    [unit_js_1.Unit.MAD]: [BrandKey.MAD],
    [unit_js_1.Unit.MLK]: [BrandKey.MLK],
    [unit_js_1.Unit.MVO]: [BrandKey.MVO],
    [unit_js_1.Unit.NEON]: [BrandKey.NEO],
    [unit_js_1.Unit.NGE]: [BrandKey.NGE],
    [unit_js_1.Unit.PECO]: [BrandKey.ATN, BrandKey.CAP, BrandKey.HBR, BrandKey.MAN],
    [unit_js_1.Unit.PFEM]: [
        BrandKey.BEA,
        BrandKey.CAC,
        BrandKey.FAC,
        BrandKey.FLW,
        BrandKey.OMM,
        BrandKey.PRA,
        BrandKey.SIM,
        BrandKey.SRG,
    ],
    [unit_js_1.Unit.PMEDIA]: [BrandKey.PMEDIA],
    [unit_js_1.Unit.PMO]: [BrandKey.UKSAS, BrandKey.DESAS],
    [unit_js_1.Unit.PTVS]: [
        BrandKey.CTP,
        BrandKey.CTR,
        BrandKey.TEL,
        BrandKey.TGC,
        BrandKey.TLA,
        BrandKey.TLS,
        BrandKey.TLZ,
        BrandKey.TVJ,
    ],
    [unit_js_1.Unit.QUOI]: [BrandKey.QUOI],
    [unit_js_1.Unit.SESH]: [BrandKey.SESH],
    [unit_js_1.Unit.SHG]: [
        BrandKey.SHGCAC,
        BrandKey.SHGCAM,
        BrandKey.SHGFAC,
        BrandKey.SHGGEO,
        BrandKey.SHGTEL,
        BrandKey.SHGVOI,
    ],
    [unit_js_1.Unit.TGL]: [BrandKey.TGL],
    [unit_js_1.Unit.TMA]: [BrandKey.TMA],
    [unit_js_1.Unit.TRV]: [BrandKey.TRV],
    [unit_js_1.Unit.TVP]: [BrandKey.TVP],
    [unit_js_1.Unit.TVS]: [BrandKey.TVS],
    [unit_js_1.Unit.VOICI]: [BrandKey.VOI],
    [unit_js_1.Unit.TESTUNIT]: [
        BrandKey.CTR,
        BrandKey.VDF,
        BrandKey.TESTBRAND,
        BrandKey.BONE,
    ],
};
exports.brandTitleByKey = {
    [BrandKey.ATN]: 'Athenee',
    [BrandKey.BEA]: 'Beauté Addict',
    [BrandKey.BIN]: 'Business insider',
    [BrandKey.BONE]: 'Bone',
    [BrandKey.BRGTS]: 'BR Gentside',
    [BrandKey.BROMM]: 'BR Ohmymag',
    [BrandKey.CAC]: 'Cuisine Actuelle',
    [BrandKey.CAM]: "Ça m'intéresse",
    [BrandKey.CAP]: 'Capital',
    [BrandKey.CBG]: 'Canal + by Prisma',
    [BrandKey.CLE]: 'CLE',
    [BrandKey.CTR]: 'Ciné Télé Revue',
    [BrandKey.CTM]: 'Côté Maison',
    [BrandKey.CTP]: '100% programme TV',
    [BrandKey.DEGTS]: 'DE Gentside',
    [BrandKey.DEOMM]: 'DE Ohmymag',
    [BrandKey.DESAS]: 'DE Seeandso',
    [BrandKey.ESGTS]: 'ES Gentside',
    [BrandKey.ESOMM]: 'ES Ohmymag',
    [BrandKey.FAC]: 'Femme Actuelle',
    [BrandKey.FATV]: 'FATV',
    [BrandKey.FDI]: 'France Dimanche',
    [BrandKey.FLW]: 'Flow',
    [BrandKey.FRGTS]: 'FR Gentside',
    [BrandKey.FRGSD]: 'FR Gentside Découverte',
    [BrandKey.FRGSG]: 'FR Gentside Gaming',
    [BrandKey.FRGSL]: 'FR Gentside Lifestyle',
    [BrandKey.FRGSS]: 'FR Gentside Sport',
    [BrandKey.FRGSV]: 'FR Gentside Voyage',
    [BrandKey.FROMM]: 'FR Ohmymag',
    [BrandKey.GAL]: 'Gala',
    [BrandKey.GEO]: 'GEO',
    [BrandKey.HBR]: 'Harvard Business Review',
    [BrandKey.HBZ]: "Harper's Bazaar",
    [BrandKey.HCO]: 'Hellocoton',
    [BrandKey.IDE]: 'Ideat',
    [BrandKey.IDEAT]: 'Ideat',
    [BrandKey.ICI]: 'Ici Paris',
    [BrandKey.ITGTS]: 'IT Gentside',
    [BrandKey.ITOMM]: 'IT Ohmymag',
    [BrandKey.JDD]: 'Journal du Dimanche',
    [BrandKey.JDM]: 'JD Mag',
    [BrandKey.JDN]: 'JD News',
    [BrandKey.MAD]: 'MAD',
    [BrandKey.MAN]: 'Management',
    [BrandKey.MCE]: 'Maisons Côté Est',
    [BrandKey.MCO]: 'Maisons Côté Ouest',
    [BrandKey.MCS]: 'Maisons Côté Sud',
    [BrandKey.MLK]: 'Milk',
    [BrandKey.MVO]: 'MVO',
    [BrandKey.NEO]: 'Néon',
    [BrandKey.NGE]: 'National Geographic',
    [BrandKey.OMM]: 'Ohmymag',
    [BrandKey.PMEDIA]: 'PMEDIA',
    [BrandKey.PRA]: 'Prima',
    [BrandKey.QUOI]: 'Quoi',
    [BrandKey.SESH]: 'Sesh',
    [BrandKey.SHGCAC]: 'Shopping CAC',
    [BrandKey.SHGCAM]: 'Shopping CAM',
    [BrandKey.SHGFAC]: 'Shopping FAC',
    [BrandKey.SHGGEO]: 'Shopping GEO',
    [BrandKey.SHGTEL]: 'Shopping TEL',
    [BrandKey.SHGVOI]: 'Shopping VOI',
    [BrandKey.SIM]: 'Simone',
    [BrandKey.SRG]: 'Femme Actuelle Senior',
    [BrandKey.TEL]: 'Télé-loisirs',
    [BrandKey.TGC]: 'Ce soir TV',
    [BrandKey.TLA]: 'Télé-loisirs Afrique',
    [BrandKey.TGL]: 'The Good Life',
    [BrandKey.TLS]: 'Télé 2 semaines',
    [BrandKey.TLZ]: 'Télé Z',
    [BrandKey.TMA]: 'TMA',
    [BrandKey.TRV]: 'Transverse',
    [BrandKey.TVJ]: 'Télé + de jeux + lisible',
    [BrandKey.TVP]: 'TVP',
    [BrandKey.TVS]: 'Programmes TV 15 jours',
    [BrandKey.UKGTS]: 'UK Gentside',
    [BrandKey.UKOMM]: 'UK Ohmymag',
    [BrandKey.UKSAS]: 'UK Seeandso',
    [BrandKey.VDF]: 'Vie de Famille',
    [BrandKey.VOI]: 'Voici',
    [BrandKey.TESTBRAND]: 'Test brand',
};
function isBrandKey(maybeBrandKey) {
    return Object.entries(BrandKey).some(([, brandKey]) => brandKey === maybeBrandKey);
}
exports.isBrandKey = isBrandKey;
function assertBrandKey(maybeBrandKey) {
    if (!isBrandKey(maybeBrandKey)) {
        throw new Error(`The brandKey "${maybeBrandKey}" does not exist.`);
    }
    return maybeBrandKey;
}
exports.assertBrandKey = assertBrandKey;
function getBrandKeysForUnits(units) {
    return units.reduce((brandKeys, unit) => [...brandKeys, ...exports.brandKeysByUnit[unit]], []);
}
exports.getBrandKeysForUnits = getBrandKeysForUnits;
function getBrandLang(brandKey) {
    const foreignBrandkeys = {
        [BrandKey.BRGTS]: 'PT',
        [BrandKey.BROMM]: 'PT',
        [BrandKey.DEGTS]: 'DE',
        [BrandKey.DEOMM]: 'DE',
        [BrandKey.DESAS]: 'DE',
        [BrandKey.ESGTS]: 'ES',
        [BrandKey.ESOMM]: 'ES',
        [BrandKey.ITGTS]: 'IT',
        [BrandKey.ITOMM]: 'IT',
        [BrandKey.UKGTS]: 'EN',
        [BrandKey.UKOMM]: 'EN',
        [BrandKey.UKSAS]: 'EN',
    };
    return foreignBrandkeys[brandKey] ?? 'FR';
}
exports.getBrandLang = getBrandLang;
//# sourceMappingURL=brand.js.map